import { useIntl } from 'react-intl'
import { useEffect, useState } from 'react'
import { createClient } from '@supabase/supabase-js'
import { EnableSidebar, PageTitle } from '../../../_metronic/layout/core'
import {
  MixedWidget13,
  MixedWidget14,
  CompleteSettings,
} from '../../../_metronic/partials/widgets'
import usePlacesList from '../../../ofindo/utils/hasPlaces'
import PlacesList from '../../modules/apps/places/widgets/PlacesList'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';
const supabase = createClient(supabaseUrl, supabaseAnonKey);

const DashboardPage = () => {
  const { hasPlaces } = usePlacesList()

  return (
    <>
      <div className='card card-xl-stretch mb-5'>
        {/* begin::Header */}
        <div className='card-header px-5'>
          <h3 className='card-title fw-bold text-dark'>Die ersten Schritte im Partnerportal</h3>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body p-5'>
          <CompleteSettings />
        </div>
        {/* end::Body */}
      </div>

      {/* Nur anzeigen, wenn Places vorhanden sind */}
      {hasPlaces && (
        <div className='card card-xl-stretch mb-5'>
          {/* begin::Header */}
          <div className='card-header px-5'>
            <h3 className='card-title fw-bold text-dark'>Partnerprofil</h3>
          </div>
          {/* end::Header */}
          {/* begin::Body */}
          <div className='card-body p-5 pb-2'>
            <PlacesList />
          </div>
          {/* end::Body */}
        </div>
      )}

      <div className='row gy-5 g-xl-10'>
        {/*begin::Col*/}
        <div className='col-xl-4'>
          <MixedWidget13
            className='card-xl-stretch mb-xl-10'
            backGroundColor='#F7D9E3'
            chartHeight='100px'
          />
        </div>
        {/*end::Col*/}

        {/*begin::Col*/}
        <div className='col-xl-4'>
          <MixedWidget14
            className='card-xl-stretch mb-xl-10'
            backGroundColor='#CBF0F4'
            chartHeight='100px'
          />
        </div>
        {/*end::Col*/}
      </div>
      {/*end::Row*/}
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const fetchUserFromCache = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        setUser(session.user);
      }
    };
    fetchUserFromCache();
  }, []);

  const username = user?.user_metadata?.first_name ||
    user?.user_metadata?.last_name ||
    user?.email ||
    '';

  return (
    <EnableSidebar>
      <PageTitle>
        Hallo Moin{username ? ` ${username}` : ''}
      </PageTitle>
      <DashboardPage />
    </EnableSidebar>
  )
}

export { DashboardWrapper }
